/**
 * Feature flags — build-time constants.
 *
 * Default OFF for anything user-facing that isn't fully wired through yet.
 * Flip in a build (env var) when ready to enable, rather than shipping
 * incomplete UI behind a runtime toggle.
 *
 * See docs/MONETIZATION_MODEL.md "Launch posture" for why monetization
 * is hidden-not-greyed-out.
 */

const flag = (envKey, defaultValue = false) => {
  const v = import.meta.env?.[envKey];
  if (v === undefined) return defaultValue;
  return v === 'true' || v === '1' || v === true;
};

export const MONETIZATION_ENABLED = flag('VITE_MONETIZATION_ENABLED', false);

// Tasks/Next Up is still an unfinished product slice. Keep every discoverable
// web entry point hidden until the assignee and parent journeys are ready to
// ship together. The underlying routes and data remain available for review.
export const TASKS_ENABLED = flag('VITE_TASKS_ENABLED', false);
